import React, { useEffect, useState } from "react";

import { Button, Drawer } from "antd";
import type { DrawerProps } from "antd";

import CardRound from "./cardround";

import { Link, useNavigate } from "react-router-dom";
import { dataListsType } from "./featured-posts";
import { DataLists } from "../dataLists/DataLists";

const DrawerBar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState<DrawerProps["size"]>();

  const showDefaultDrawer = () => {
    setSize("default");
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();

  const handleClickHotTopics = (label: string) => {
    const routes: { [key: string]: string } = {
      旅行のヒント: "/travel",
      住む場所: "/hotels",
      おいしい食べ物: "/food",
      やること: "/guides",
    };
    navigate(routes[label] || "/");
  };

  const [destinationChinaData, setDestinationChinaData] = useState<
    dataListsType[]
  >([]);
  const [destinationJapanData, setDestinationJapanData] = useState<
    dataListsType[]
  >([]);
  const [destinationIndonesiaData, setDestinationIndonesiaData] = useState<
    dataListsType[]
  >([]);
  const [worthgoingData, setWorthgoingData] = useState<dataListsType[]>([]);

  const getDestinationData = () => {
    const allData = [...DataLists];

    const destinationChinaData2 = allData.filter(
      (item) => item.nation === "中國"
    );
    const destinationJapanData2 = allData.filter(
      (item) => item.nation === "日本"
    );
    const destinationIndonesiaData2 = allData.filter(
      (item) => item.nation === "インドネシア"
    );
    setDestinationChinaData(
      destinationChinaData2.sort(() => 0.5 - Math.random()).slice(0, 1)
    );
    setDestinationJapanData(
      destinationJapanData2.sort(() => 0.5 - Math.random()).slice(0, 1)
    );
    setDestinationIndonesiaData(
      destinationIndonesiaData2.sort(() => 0.5 - Math.random()).slice(0, 1)
    );
  };

  const getWorthgoingData = () => {
    const allData = [...DataLists];

    const allworthgoingData = allData.filter(
      (item) => item.category === "旅行"
    );
    setWorthgoingData(
      allworthgoingData.sort(() => 0.5 - Math.random()).slice(0, 1)
    );
  };

  useEffect(() => {
    getDestinationData();
    getWorthgoingData();
  }, []);

  return (
    <>
      <Button type="text" onClick={showDefaultDrawer}>
        <img src="icon/list.png" alt="listIcon" className="w-6 h-6" />
      </Button>

      <Drawer
        title=""
        placement="right"
        size={size}
        onClose={onClose}
        open={open}
      >
        <div className="w-full flex flex-col">
          <div className="mb-3 border-b-[1px]">
            <h5 className="text-xs font-semibold pt-2 pb-2 tracking-widest">
              ホットトピック
            </h5>
            <span className="block w-14 h-[3px] bg-black"></span>
          </div>
          <ul className="flex flex-col">
            {[
              { label: "旅行のヒント", nums: "30" },
              { label: "目的地", nums: "15" },
              { label: "住む場所", nums: "8" },
              { label: "おいしい食べ物", nums: "22" },
              { label: "やること", nums: "25" },
            ].map((item, index) => (
              <li
                key={index}
                className="flex items-center justify-between border-b-[1px] border-dotted border-[#d1d2d3] last-of-type:border-b-0 py-2.5 /*last-of-type:border-b-0*/ group"
              >
                <b
                  className="text-sm font-medium cursor-pointer text-gray-500 hover:text-[#5b68d3]"
                  onClick={() => handleClickHotTopics(item.label)}
                >
                  {item.label}
                </b>
                {/* <span className="w-6 h-6 text-xs text-white font-medium flex items-center justify-center bg-[#5c687a] rounded-full group-hover:bg-[#e62437] hover:bg-[#e62437]">
                  {item.nums}
                </span> */}
              </li>
            ))}
          </ul>
        </div>
        <div className="w-full flex flex-col">
          <div className="mt-10 mb-8  border-b-[1px]">
            <h5 className="text-xs font-semibold pt-2 pb-2 tracking-widest">
              目的地
            </h5>
            <span className="block w-14 h-[3px] bg-black"></span>
          </div>

          <CardRound props={destinationChinaData} />
          <CardRound props={destinationJapanData} />
          <CardRound props={destinationIndonesiaData} />
        </div>
        <div className="w-full flex flex-col">
          <div className="mt-4 mb-8 border-b-[1px]">
            <h5 className="uppercase text-xs font-semibold pt-2 pb-2 tracking-widest">
              行ってみる価値がある場所
            </h5>
            <span className="block w-14 h-[3px] bg-black"></span>
          </div>
          {worthgoingData.map((item, key: number) => {
            return (
              <Link
                to={{
                  pathname: `/detailspage`,
                  search: `?id=${item.id}&${item.category}/${item.urlinform}/`,
                }}
                target="_top"
                key={key}
              >
                <div className="w-full max-h-[374px] bg-[#f5f6f7] rounded-md overflow-hidden mb-10">
                  <img
                    src={item.images[0]}
                    alt={item.title}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
              </Link>
            );
          })}
        </div>
      </Drawer>
    </>
  );
};

export default DrawerBar;
